import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { IonIcon } from "@ionic/react";
import { closeCircleOutline } from "ionicons/icons";
import Marquee from "react-fast-marquee";
export default function TopAdBar({ hideTopBar = false, onHideTopBar }) {
    const featuredAds = [
        'Buy Verified Products, Find Licensed Doctors.',
        'Get Trusted Healthcare Services Near You.',
        'Fast Delivery on Medical Supplies Nationwide.'
    ];
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("div", {
            className: `
          topAdBar slowmo flex flex-col items-center justify-center w-full xlg:w-120 xlg:mx-auto xlg:px-4 h-8 bg-[#d6e9ff] dark:bg-gray-800
          transform
          ${!hideTopBar ? 'relative top-0' : 'z-[999] absolute -top-[100px] left-full'}
        `,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between h-full parent-container xlg:w-[calc(100%-16px)]",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-between gap-2 text-xs text-[#111827] font-dm_sans font-normal",
                        children: [
                            /*#__PURE__*/ _jsxs("svg", {
                                width: "16px",
                                height: "16px",
                                viewBox: "0 0 36 36",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true",
                                role: "img",
                                preserveAspectRatio: "xMidYMid meet",
                                children: [
                                    /*#__PURE__*/ _jsx("path", {
                                        fill: "#009A49",
                                        d: "M4 5a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h8V5H4z"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        fill: "#EEE",
                                        d: "M12 5h12v26H12z"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        fill: "#009A49",
                                        d: "M32 5h-8v26h8a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: "Nigeria"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "xhidden lg:block flex-1 mx-4 overflow-hidden",
                        children: /*#__PURE__*/ _jsx(Marquee, {
                            speed: 40,
                            pauseOnHover: true,
                            gradient: false,
                            children: featuredAds.map((ad, index)=>/*#__PURE__*/ _jsx("p", {
                                    className: "whitespace-nowrap text-xs font-light text-[#111827] font-dm_sans text-center opacity-90 mx-6",
                                    children: ad
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center font-normal justify-end space-x-2 text-xs text-[#111827] font-dm_sans",
                        children: /*#__PURE__*/ _jsx(IonIcon, {
                            icon: closeCircleOutline,
                            className: "size-5 cursor-pointer",
                            title: "Close",
                            onClick: ()=>{
                                if (onHideTopBar) onHideTopBar();
                            }
                        })
                    })
                ]
            })
        })
    });
}

//# sourceMappingURL=TopAdBar.js.map